import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService, PaginatedResponse, Response } from '@tcc-mono/shared/data-access';
import { RvoAnimal, Stable, Veterinarian } from '@tcc-mono/vandijk/shared/data-access/models';

@Injectable({
  providedIn: 'root'
})
export class StableService extends BaseService<Stable> {
  constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/stables'
  }

  public getRvoAnimals = (stableId: number, animalSpecies?: string | null): Observable<RvoAnimal[]> => {
    const params = animalSpecies ? { animal_species: animalSpecies } : {};
    return this.getChild<RvoAnimal[]>(stableId, 'rvo/animals', params);
  }

  public getRVOPassword = (stableId: string | number): Observable<{ password: string }> => {
    return this.getChild(stableId, 'rvopassword') as Observable<{ password: string }>;
  }

  public findByUbn(ubn: string): Observable<Stable | null> {
    return this.getAll({ ubn: ubn.trim(), per_page: 1 }).pipe(
      map((response) => response?.data?.[0] ?? null),
    );
  }

  public getVeterinarians = (stableId: number): Observable<Veterinarian[]> => {
    return this.getChild<Response<Veterinarian[]>>(stableId, 'veterinarians').pipe(
      map((response: Response<Veterinarian[]>) => response.data || [])
    );
  };
}
